import React, { useState } from 'react';
import { FaTrain } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Card from '../components/Common/Card';
import TrainStatusForm from '../components/Features/TrainStatus/TrainStatusForm';
import styles from './TrainStatusPage.module.css';

const TrainStatusPage: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleTrainStatusSubmit = async (trainNumber: string, date: string) => {
    setIsLoading(true);
    // Navigate to result page with train number and date
    navigate(`/train-status/${trainNumber}/${date}`);
    setIsLoading(false);
  };

  return (
    <div className={styles.trainStatusPage}>
      <div className="container">
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>
            <FaTrain className={styles.titleIcon} />
            Live Train Running Status
          </h1>
          <p className={styles.subtitle}>
            Track your train in real-time with accurate station-wise updates
          </p>
        </div>

        {/* Train Status Form */}
        <Card className={styles.formCard}>
          <TrainStatusForm onSubmit={handleTrainStatusSubmit} isLoading={isLoading} />
        </Card>

        {/* Info Section */}
        <div className={styles.infoSection}>
          <Card className={styles.infoCard}>
            <h3 className={styles.infoTitle}>How to Check Train Status?</h3>
            <ol className={styles.infoList}>
              <li>Enter your 5-digit train number</li>
              <li>Select journey date (past, today, or future)</li>
              <li>Click "Check Train Status" to view live updates</li>
            </ol>
          </Card>

          <Card className={styles.infoCard}>
            <h3 className={styles.infoTitle}>Features</h3>
            <ul className={styles.infoList}>
              <li>Real-time station-wise train tracking</li>
              <li>Actual vs Scheduled timings</li>
              <li>Delay information at each station</li>
              <li>Visual progress timeline</li>
            </ul>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TrainStatusPage;